// ── Hash-based SPA router ──

const routes = [];
let currentCleanup = null;

function addRoute(pattern, handler) {
  const paramNames = [];
  const regexStr = pattern.replace(/:(\w+)/g, (_, name) => {
    paramNames.push(name);
    return '([^/]+)';
  });
  routes.push({ regex: new RegExp('^' + regexStr + '$'), paramNames, handler });
}

function navigate(path) {
  // '/' is workspace-scoped and never project-gated — it always resolves to the
  // dashboard regardless of which project (if any) was previously selected (C1275).
  const target = '#' + path;
  // If we're already at the target route, a plain hash assignment is a
  // no-op — no 'hashchange' event fires, so the route never re-renders
  // (e.g. login page bouncing to '/' when the app is already sitting on
  // '/' post-redirect). Force a re-resolve in that case.
  if (window.location.hash === target) {
    resolve();
  } else {
    window.location.hash = target;
  }
}

function resolve() {
  const raw = window.location.hash.slice(1) || '/';
  const qIdx = raw.indexOf('?');
  const hash = qIdx >= 0 ? raw.slice(0, qIdx) : raw;

  if (typeof currentCleanup === 'function') {
    currentCleanup();
    currentCleanup = null;
  }

  for (const route of routes) {
    const match = hash.match(route.regex);
    if (match) {
      const params = {};
      route.paramNames.forEach((name, i) => { params[name] = match[i + 1]; });
      currentCleanup = route.handler(params) || null;
      return;
    }
  }

  navigate('/');
}

function start() {
  window.addEventListener('hashchange', resolve);
  resolve();
}

function getCurrentPath() {
  return window.location.hash.slice(1) || '/';
}

function getQueryParams() {
  const raw = window.location.hash.slice(1) || '/';
  const qIdx = raw.indexOf('?');
  if (qIdx < 0) return new URLSearchParams();
  return new URLSearchParams(raw.slice(qIdx + 1));
}

function setQueryParams(params) {
  const raw = window.location.hash.slice(1) || '/';
  const qIdx = raw.indexOf('?');
  const path = qIdx >= 0 ? raw.slice(0, qIdx) : raw;
  const qs = params.toString();
  const newHash = qs ? '#' + path + '?' + qs : '#' + path;
  history.replaceState(null, '', newHash);
}

export { addRoute, navigate, start, resolve, getCurrentPath, getQueryParams, setQueryParams };
